import './pageHeader.scss';
import React, { useLayoutEffect, useState, useEffect, useRef, useContext } from 'react';
import { isInIframe } from '../../common/utils/umuUtil';
import If from '../../common/components/if';
import { getHeight } from '../../utils/domHelper';
import { $document } from '../../common/utils/bom';
import { AppContext } from '../../context/appContext';

export interface IProps {
    showFixedHolder: boolean;
    children: React.ReactElement;
    renderLogo: () => React.ReactElement;
}


export function PageHeader(props: IProps) {
    const elRef = useRef<HTMLDivElement>();
    const [showHeader, setShowHeader] = useState(false);
    const appContext = useContext(AppContext);
    const { children, renderLogo, showFixedHolder } = props;

    useLayoutEffect(() => {
        const inIframe = isInIframe();
        setShowHeader(!inIframe);
    }, [])

    useEffect(() => {
        const inIframe = isInIframe();
        setShowHeader(!inIframe);
        if (showFixedHolder) {
            addFixedHolder();
        }
        return () => {
            const el = elRef.current;
            if (!el || !el.remove) {
                return;
            }
            el.remove();
        }
    }, []);

    const addFixedHolder = () => {
        const el = elRef.current;
        if (!el || !el.parentElement) {
            return;
        }
        const height = getHeight(el);
        const holder = $document.createElement('div');
        if (!holder) {
            return;
        }
        holder.style.height = `${height}px`;
        el.parentElement.appendChild(holder);
    }

    // const addFixedHolder1 = () => {
    //     var $el = $(iElement);
    //     var height = $el.height();
    //     var $holder = $('<div>');
    //     $holder.css({
    //         height: height
    //     });
    //     $el.after($holder);

    //     scope.$on('$destroy', function () {
    //         $el.remove();
    //     });
    // }

    return (
        <If condition={showHeader}>
            <div className={`common-header-page-header ${appContext.state.lang} ${appContext.state.siblingSubHeader ? 'siblign-sub-header': ''}`} ref={elRef}>
                <div className="common-header-page-header-wrap">
                    {renderLogo()}
                    <div>{children}</div>
                </div>
            </div>
        </If>
    );
}
